import React from 'react';
import styled from 'styled-components';

export const DarkBackgroundWrapper = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  background-color: rgba(0, 0, 0, 0.7);
  z-index: 501;
  display: flex;
  justify-content: center;
  align-items: center;
`;

export const DarkBackground: React.FC = ({children}) => {
  return <DarkBackgroundWrapper>{children}</DarkBackgroundWrapper>;
};
